import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const STATE = {
  disponibile: ["Disponibile", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  sottoscorta: ["Sottoscorta", "bg-amber-100 text-amber-800 border-amber-300"],
  esaurito: ["Esaurito", "bg-rose-100 text-rose-700 border-rose-300"],
  catalogo: ["Solo catalogo", "bg-slate-100 text-slate-600 border-slate-300"],
};
export const PTYPE = { originale: "Originale", compatibile: "Compatibile", rigenerata: "Rigenerata", vuota: "Vuota ricaricabile", toner: "Toner", altro: "Altro" };

export function StateBadge({ s, testid }) {
  const [l, c] = STATE[s] || STATE.catalogo;
  return <span data-testid={testid} className={`inline-block whitespace-nowrap text-[11px] font-bold uppercase px-2 py-0.5 rounded border ${c}`}>{l}</span>;
}

const STORE_KEY = "hs_wh_store";
export function useStore() {
  const [stores, setStores] = useState([{ id: "sede", name: "Negozio principale" }]);
  const [store, setS] = useState(() => localStorage.getItem(STORE_KEY) || "sede");
  useEffect(() => { api.get("/admin/stores").then((r) => setStores(r.data)).catch(() => {}); }, []);
  const setStore = (s) => { localStorage.setItem(STORE_KEY, s); setS(s); };
  return { stores, store, setStore };
}

export function StorePicker({ stores, store, setStore }) {
  if (stores.length < 2) return null;
  return (
    <select data-testid="wh-store-select" value={store} onChange={(e) => setStore(e.target.value)} className="h-10 px-3 rounded-md border bg-white text-sm font-semibold">
      {stores.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}
    </select>
  );
}

let pendingSubs = new Set();
export const refreshPending = () => api.get("/admin/printers/pending-count").then((r) => pendingSubs.forEach((f) => f(r.data.count))).catch(() => {});
export function usePendingCount() {
  const [n, setN] = useState(0);
  useEffect(() => { pendingSubs.add(setN); refreshPending(); return () => pendingSubs.delete(setN); }, []);
  return n;
}

export const sendToCassa = (row) => {
  const list = JSON.parse(sessionStorage.getItem("hs_cassa_add") || "[]");
  list.push({ code: row.code, description: row.description, price: row.price, vat: row.vat ?? 22 });
  sessionStorage.setItem("hs_cassa_add", JSON.stringify(list));
};
